import React from 'react';
import { useLang } from '../i18n';

function BpEchoMainMenu({ onStartFreeChat, onConversationPractice }) {
  const { t } = useLang();

  return (
    <div className="bp-echo-main-menu">
      <div className="menu-section">
        <h3>{t.freeChat}</h3>
        <div className="menu-buttons-container">
          <button
            className="menu-button-image"
            onClick={() => onStartFreeChat('introductions')}
            style={{
              backgroundImage: `url("${process.env.PUBLIC_URL}/assets/menu-buttons/topic-buttons/introductions-1.png")`
            }}
          >
            <span className="menu-button-label">{t.introductions}</span>
          </button>
          <button
            className="menu-button-image"
            onClick={() => onStartFreeChat('likes-dislikes')}
            style={{
              backgroundImage: `url("${process.env.PUBLIC_URL}/assets/menu-buttons/topic-buttons/likes_dislikes-1.png")`
            }}
          >
            <span className="menu-button-label">{t.likesDislikes}</span>
          </button>
          <button
            className="menu-button-image"
            onClick={() => onStartFreeChat('hobbies')}
            style={{
              backgroundImage: `url("${process.env.PUBLIC_URL}/assets/menu-buttons/topic-buttons/hobbies.png")`
            }}
          >
            <span className="menu-button-label">{t.hobbies}</span>
          </button>
        </div>
      </div>

      <div className="menu-section">
        <h3>{t.conversationPractice}</h3>
        <div className="menu-buttons-container">
          <button
            className="menu-button-image grade-button"
            onClick={() => onConversationPractice('grade5')}
            style={{
              backgroundImage: `url("${process.env.PUBLIC_URL}/assets/menu-buttons/topic-buttons/grade_5.png")`
            }}
          >
            <span className="menu-button-label">{t.grade5}</span>
          </button>
          <button
            className="menu-button-image grade-button"
            onClick={() => onConversationPractice('grade6')}
            style={{
              backgroundImage: `url("${process.env.PUBLIC_URL}/assets/menu-buttons/topic-buttons/grade_6.png")`
            }}
          >
            <span className="menu-button-label">{t.grade6}</span>
          </button>
        </div>
      </div>
    </div>
  );
}

export default BpEchoMainMenu;
